import { inject, Injectable } from '@angular/core';
import { OptionCode } from '@cardium/contracts';
import { OptionStore } from '../stores';

@Injectable({ providedIn: 'root' })
export class ClinicOptionsService {
  private readonly store = inject(OptionStore);

  public readonly clinicType = this.store.getOptionString(
    OptionCode.ClinicOption.USERFORM,
  );
}
